export const SUPPORTED_LANGUAGES = {
    en: { name: 'English', nativeName: 'English', flag: '🇬🇧' },
    de: { name: 'German', nativeName: 'Deutsch', flag: '🇩🇪' },
    fr: { name: 'French', nativeName: 'Français', flag: '🇫🇷' },
    it: { name: 'Italian', nativeName: 'Italiano', flag: '🇮🇹' },
    es: { name: 'Spanish', nativeName: 'Español', flag: '🇪🇸' },
};
export const DEFAULT_LANGUAGE = 'en';
export const NAMESPACES = [
    'common',
    'auth',
    'transformation',
    'subscription',
    'settings',
    'legal',
    'errors',
    'landing',
    'help',
    'seo',
    'blog',
];
export function getSupportedLanguageCodes() {
    return Object.keys(SUPPORTED_LANGUAGES);
}
export function isSupportedLanguage(lang) {
    return lang in SUPPORTED_LANGUAGES;
}
export function getLanguageMetadata(lang) {
    return SUPPORTED_LANGUAGES[lang];
}
export function getAllLanguagesMetadata() {
    return getSupportedLanguageCodes().map((code) => ({
        code,
        ...SUPPORTED_LANGUAGES[code],
    }));
}
